import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let MiscellaneousOnsiteIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M12 0c4.549 0 8.25 3.701 8.25 8.25 0 1.631-.996 4.375-2.961 8.155-1.59 3.058-3.337 5.867-4.039 6.925-.277.421-.748.674-1.252.671-.502 0-.97-.252-1.248-.671-.702-1.057-2.448-3.866-4.039-6.925C4.746 12.625 3.75 9.882 3.75 8.25 3.75 3.701 7.451 0 12 0zm0 1.5c-3.726.004-6.746 3.024-6.75 6.75 0 2.88 4.396 10.702 6.75 14.25 2.354-3.548 6.75-11.371 6.75-14.25-.004-3.726-3.024-6.746-6.75-6.75zm0 2.25c2.481 0 4.5 2.019 4.5 4.5s-2.019 4.5-4.5 4.5-4.5-2.019-4.5-4.5 2.019-4.5 4.5-4.5zm0 1.5c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
MiscellaneousOnsiteIcon = __decorateClass([
  customElement("elm-miscellaneous-onsite-icon")
], MiscellaneousOnsiteIcon);
export { MiscellaneousOnsiteIcon };
